import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { DatadogProvider } from './components/Datadog/Datadog';
import { RenderModeProvider } from './hooks/renderMode';
import type { ClientContext } from './types/sku';

export default ({ environment, version }: ClientContext) => {
  hydrateRoot(
    document.getElementById('app')!,
    <BrowserRouter>
      <DatadogProvider environment={environment} version={version}>
        <RenderModeProvider mode="client">
          <App environment={environment} />
        </RenderModeProvider>
      </DatadogProvider>
    </BrowserRouter>,
  );
};
